export default {
  handler: 'relativeUrl',
  data: ({ gameId }) => (
    `/casino/games/${gameId}/launch`
  ),
};
